export default {
  myBalance: 'Moje saldo',
  topUp: 'Doładuj',
  pay: 'Doładuj',
  repayment: 'Ponów płatność',
  balance: 'saldo',
  usableBalance: 'dostępne środki',
  inputBalance: 'Wprowadź kwotę',
  payBalance: 'kwota doładowania',
  pecenter: 'Panel użytkownika',
  lang: 'Język',
  cart: 'Koszyk',
  recipientName: 'Odbiorca',
  goRecharge: 'Doładuj teraz',
  phone: 'Telefon',
  region: 'Region',
  address: 'Dokładny adres',
  country: 'Kraj lub region',
  province: 'Województwo',
  city: 'Miasto',
  postcode: 'Kod pocztowy',
  action: 'Operacja',
  mobileSettings: 'Ustawienia mobilne',
  name: 'Imię i nazwisko',
  debt: 'ZADŁUŻENIE',
  add: 'Dodaj adres rozliczeniowy karty',
  addSuccess: 'Dodano pomyślnie',
  editSuccess: 'Edytowano pomyślnie',
  editBtn: 'Edytuj',
  edit: 'Edytuj adres rozliczeniowy karty',
  del: 'Usuń',
  setDefault: 'Ustaw jako domyślny',
  defaultAddress: 'Adres domyślny',
  setDefaultAddress: 'Ustaw jako domyślny adres dostawy',
  setSuccess: 'Ustawiono pomyślnie',
  myAddress: 'Moje adresy',
  addAddress: 'Dodaj nowy adres',
  tradeTime: 'Czas transakcji',
  type: 'Typ',
  incomeOrExpend: 'Przychód/Wydatek',
  accountBalance: 'Saldo konta',
  tradeNo: 'ID transakcji',
  remark: 'Uwagi',
  tag: 'Etykieta adresu',
  addBillAddress: 'Dodaj adres rozliczeniowy karty',
  deleteBillAddress: 'Usuń adres rozliczeniowy',
  editBillAddress: 'Edytuj adres rozliczeniowy',
  mergePay: 'Zapłać razem',
  username: 'Nazwa użytkownika',
  gender: 'Płeć',
  birthday: 'Data urodzenia',
  avatar: 'Awatar',
  email: 'E-mail',
  site: 'Strona',
  myOrder: 'Zamówienia',
  sideBar: {
    myAccount: 'Moje konto',
    addressManage: 'Zarządzanie adresami',
    myAsset: 'Portfel',
    billAddress: 'Adres rozliczeniowy',
  },
  addDoorNoTips: `Proszę dodać numer domu do adresu dostawy.`,
  holder: {
    receiver: 'Odbiorca',
    firstName: 'Imię',
    name: 'Nazwisko',
    region: 'Wybierz województwo/miasto/dzielnicę/ulicę',
    address:
      'Wprowadź szczegółowy adres, np. ulicę, numer domu, osiedle, numer budynku, mieszkanie itp.',
    phone: 'Numer telefonu, wymagane wypełnienie jednego pola',
    input: 'wprowadź',
    select: 'wybierz',
    tagHolder: 'Maks. 120 znaków (opcjonalnie)',
    postCodeNoMatch: 'Kod pocztowy nie pasuje do regionu',
    doorNo: 'Numer domu',
  },
  forget: {
    accountSafe: 'Bezpieczeństwo konta',
    setPwd: 'Zmień hasło',
    inputBindEmail: 'Wprowadź przypisany adres e-mail',
    inputVerifyCode: 'Wprowadź kod weryfikacyjny',
    inputPwd: 'Wprowadź nowe hasło',
  },
  accountInfo: {
    name: 'Konto',
    selfInfo: 'Informacje osobiste',
    cardBillAddress: 'Adres rozliczeniowy karty',
    shipAddress: 'Adres dostawy',
    editUser: 'Edytuj informacje użytkownika',
    inputCountry: 'Wprowadź swój kraj',
    editEmail: 'Edytuj e-mail',
    editEmailHint: '(Zalecane tylko gdy e-mail jest ustawiony nieprawidłowo lub ma problemy)',
    editEmailHint1:
      'Dla bezpieczeństwa konta musisz najpierw przejść weryfikację bezpieczeństwa z "kodem weryfikacyjnym e-mail + hasłem logowania"',
    editEmailHint2:
      'Dla bezpieczeństwa konta musisz najpierw przejść weryfikację bezpieczeństwa z "kodem weryfikacyjnym e-mail"',
    currentEmail: 'Obecny e-mail',
    clickVerify: 'Wyślij',
    reGet: 'Wyślij ponownie',
    nextStep: 'Następny krok',
    notReGetCode: ' Wyślij ponownie po',
    logoutAccount: 'Wyloguj konto',
    emailNotEmpty: 'E-mail nie może być pusty',
    logoutReason: 'Wybierz powód wylogowania',
    latelyLogin: 'Ostatnie logowanie',
    moreRecord: 'Więcej wpisów',
    visitRecord: 'Historia odwiedzin',
    visitTime: 'Czas odwiedzin',
    ipAndDevice: 'Adres IP i typ urządzenia',
    editLoginPwdHint:
      'Bezpieczne hasło zwiększa bezpieczeństwo Twojego konta. Zalecamy regularną zmianę hasła i ustawienie hasła zawierającego cyfry i litery, dłuższego niż 6 znaków.',
    editPayPwdHint:
      'Hasło wymagane przy korzystaniu z salda acbuy do płatności, ustaw hasło płatności, aby zapewnić bezpieczeństwo płatności.',
    editVerifyEmailHint: 'Aby chronić bezpieczeństwo Twojego konta, zweryfikuj swój e-mail.',
    payPwd: 'Hasło płatności',
    editPayPwd: 'Zmień hasło płatności',
    setPayPwd: 'Ustaw hasło płatności',
    deleteAccount: 'Usuń konto',
  },
  logoutReasonEnum: {
    0: 'Problemy z bezpieczeństwem/prywatnością',
    1: 'Słaba obsługa klienta',
    2: 'Za wysokie koszty',
    3: 'Skomplikowany proces zakupów',
    4: 'Inne powody',
  },
  tradeTypeEnum: {
    0: 'Przychód',
    1: 'Wydatek',
  },
  asset: {
    currentBalance: 'Aktualne saldo',
    canWithdrawBalance: 'Kwota dostępna do wypłaty',
    withdraw: 'Wypłać',
    serialNo: 'Nr seryjny',
    amount: 'Kwota',
    lossAmount: 'Wydana kwota',
    withdrawAmount: 'Kwota wypłaty',
    inputWithdrawAmount: 'Wprowadź kwotę wypłaty',
    withdrawSuccess: 'Wypłata została wysłana, przetwarzanie może potrwać do 72 godzin.',
    transactionDate: 'Data transakcji',
    withdrawMethod: 'Metoda wypłaty',
    availableAmount: 'Dostępna kwota',
    transactionNo: 'Numer transakcji',
    withdrawMsg:
      'Uwaga: Wypłata salda zostanie zwrócona poprzez oryginalny kanał. Saldo zostanie zwrócone na konto płatnicze transakcji wypłaty zgodnie z historycznym rejestrem wydatków.',
    transactionRecordsText: 'Historia transakcji dostępnej kwoty',
    withdrawRecordText: 'Historia wypłat',
  },
  package: {
    packageInfo: 'Informacje o paczce',
    weightHaveUnit: 'Waga (g)',
    sizeHaveUnit: 'Rozmiar (cm)',
    freight: 'Koszt wysyłki',
    fee: 'Opłata',
    transportMode: 'Sposób dostawy',
    allPackage: 'Wszystkie paczki',
    myPackage: 'Paczka',
  },
  packageStatusEnum: {
    0: 'Zaległe środki',
    1: 'Nieopłacone',
    2: 'W transporcie',
    3: 'Zakończone',
    4: 'Anulowane',
  },
  storage: {
    name: 'Magazyn',
    warehouseTime: 'Czas przyjęcia do magazynu',
    submitTransport: 'Złóż do wysyłki',
    lineCanUse: 'Dostępne sztuki',
    commonImg: 'Zdjęcia QC',
    customPhoto: 'Zdjęcia na zamówienie',
    extendCare: 'Wydłużony okres przechowywania',
    extendHint:
      'Okres przechowywania Twojego produktu w magazynie zostanie wydłużony o (30*N) dni, a nowa data ważności to',
    packMode: 'Metoda pakowania',
    retainPack: 'Zachowaj opakowanie',
    normalPack: 'Domyślne opakowanie',
    normalPackHint: 'Przedmioty zostaną zapakowane w ich oryginalne opakowanie.',
    foldPack: 'Opakowanie składane',
    foldPackHint:
      'W przypadku kartonów bez kleju magazyn rozłoży je, złoży na płasko i włoży do paczki użytkownika, co może zmniejszyć objętość paczki. Mogą jednak wystąpić przypadki zwiększenia objętości paczki (gdy jest mniej towarów, długość i szerokość złożonego kartonu może się zwiększyć).',
    discardPack: 'Usuń opakowanie',
    discardPackHint:
      'Po usunięciu opakowania sprzedawca może nie przyjąć zwrotu, a opakowania nie można odnaleźć/dodać z powrotem.',
    photoTemplate: 'Szablon zdjęcia',
  },
  operate: 'Operacja',
  editAddress: 'Edytuj adres',
  underPaid: 'Nieopłacone',
  goTopay: 'Przejdź do płatności',
  viewRecord: 'Zobacz historię',
  faq: 'FAQ',
  question1: 'P: Czy moje konto zostanie zamrożone, jeśli złożę wniosek o wypłatę?',
  response1:
    'O: Po złożeniu wniosku o wypłatę konto zamrozi kwotę wniosku, aby zapewnić, że kwota zwrotu będzie zgodna z kwotą, o którą wnioskowano.',
  question2:
    'P: Czy "Zakończone" w historii wypłat oznacza, że wypłata środków zakończyła się sukcesem?',
  response2:
    'O: "Zakończone" oznacza, że acbuy zorganizował zwrot, jednak czas dotarcia na Twoje oryginalne konto zależy od czasu przetwarzania platformy zewnętrznej.',
  question3: 'P: Czy wypłata opiera się na bieżącym kursie wymiany?',
  response3:
    'O: Nie, kurs wymiany przy wypłacie jest oparty na czasie, w którym środki zostały doładowane.',
  question4: 'P: Jak wypłacić, gdy saldo konta różni się od kwoty wypłaty?',
  response4:
    'O: Gdy saldo konta jest większe niż kwota wypłaty, możesz składać wnioski partiami, aż saldo konta wyniesie 0. Gdy saldo konta jest mniejsze niż kwota wypłaty, możesz złożyć jednorazowy wniosek o pełną wypłatę.',
  stillRecharge: 'Za mało środków na opłacenie zamówienia, doładuj jeszcze',
  amountDue: 'Kwota do zapłaty',
  handingFee: 'Opłata manipulacyjna',
  coupon: 'Kupon',
  couponPlaceholder: 'Wykorzystaj kupony z kodami kuponów',
  off: 'ZNIŻKA',
  minFee: 'Min. opłata',
  freightText: 'Fracht',
  limitTo: 'Limit do',
  shippingUsage: 'Wykorzystanie wysyłki',
  availableWarehouse: 'Dostępny magazyn',
  shippingFeeText: 'Koszt wysyłki (bez opłaty celnej)',
  internationalParcel: 'Paczka międzynarodowa',
  to: 'do',
  availableCoupons: 'Dostępne kupony',
  usedCoupons: 'Wykorzystane kupony',
  expiredCoupons: 'Wygasłe kupony',
  exchangeSuccess: 'Wymiana udana!',
  myAffiliate: {
    name: 'Dystrybucja',
  },
  affiliateShare: 'Udostępnij',
  copyText: 'Kopiuj',
  affiliateShareMsg:
    'Płatności za wysyłkę dokonane przez udostępnione linki wygenerują dla Ciebie prowizję.',
  businessType: 'Typ działalności',
  payWay: 'Typ transakcji',
  bzOrderNo: 'Nr AC',
  amountDueTooltip:
    'Ze względu na przeliczenia kursów walut może wystąpić różnica około 0,01 lub 0,02',
  balanceStatement: 'Wyciąg z salda',
  billFlow: 'Rachunek',
  affiliateFavorite: 'ulubiony',
  favourite: 'Ulubione',
  canUseCountry: 'Dostępne kraje',
  commonNo: 'Numer',
  question5: 'P: Jak długo trzeba czekać na wypłatę środków na mojej karcie?',
  response5:
    'O: Czas przetwarzania wypłaty może się różnić w zależności od metody płatności i banku, zazwyczaj od 2 do 25 dni. W normalnych okolicznościach wypłaty zostaną zwrócone na oryginalną metodę płatności lub doładowania w ciągu 48 godzin. Jeśli nie otrzymasz wypłaty w ciągu 48 godzin, możesz skontaktować się z obsługą klienta, aby sprawdzić aktualny status wypłaty.',
}
